import type { ReactNode } from "react";
import { IconSolidCircleWarning } from "@kalodata/kds-design-icons";
import { twMerge } from "tailwind-merge";

export interface WarningTipProps {
  className?: string;
  children: ReactNode;
}

export const WarningTip = (props: WarningTipProps) => {
  const { className, children } = props;
  return (
    <div
      className={twMerge(
        "flex items-start justify-center gap-[4px] rounded-[8px] bg-kds-bg-subtle px-[12px] py-[6px]",
        className,
      )}
    >
      <span className="flex items-center py-[3px]">
        <IconSolidCircleWarning className="size-[16px] shrink-0 text-kds-warning-fg" />
      </span>
      <div className="flex-1 text-[14px] leading-[20px] text-kds-fg-soft">{children}</div>
    </div>
  );
};
